class BuildaBundle extends HTMLElement {
  constructor() {
    super();
    this.brushList = this.querySelector('.bab-brush-list');
    this.totalItemCounts = this.querySelectorAll('.js-items-count');
    this.remainItems = this.querySelector('.js-remain-count');
    this.atcButton = this.querySelector('.js-bab-atc-sub-button');
    this.addEventListener('change', this.onBundleUpdate.bind(this));
    this.atcButton.addEventListener('click', this.onButtonClick.bind(this));
    this.mainImages = this.querySelectorAll('.build-a-bundle-product-image');
    this.imageThumbs = this.querySelectorAll('.build-a-bundle-product-image-thumb');

    this.imageThumbs.forEach((imageThumb) => {
        imageThumb.addEventListener('click', (e)=>{
            const thumb = e.target.closest('.build-a-bundle-product-image-thumb');
            if(thumb){
                const imageTarget = thumb.getAttribute('data-img-target');

                this.imageThumbs.forEach((img) => {
                    img.classList.remove('active');
                });
                thumb.classList.add('active');

                this.mainImages.forEach((img) => {
                    const imageHandle = img.getAttribute('data-img_handle');
                    if(imageHandle == imageTarget){
                        img.classList.add('active');
                    }else{
                        img.classList.remove('active');
                    }
                });
            }
        })
    })
  }

  onBundleUpdate(e) {
    const eTarget = e.target;

    if(eTarget.classList.contains('person-check-box-input')){
        const tSection = this.querySelector(".build-a-bundle-sidebar");
        const offset = tSection.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({ top: offset, behavior: "smooth" });
    }
    
    this.updateBrushs();
    this.updatePersonCount();
    this.atcUpdates();
  }

  updateBrushs() {
    const selectedBrushOption = this.querySelector('input[name="bab-block-brush-input"]:checked').value;

    if(selectedBrushOption == 'bam'){
        this.brushList.style.display = 'block';
    }else{
        this.brushList.style.display = 'none';
    }

    this.updatePersonPrice(selectedBrushOption);
  }

  updatePersonCount() { 
    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked').value;
    this.remainCountContent = this.querySelector('.js-remain-count');
    this.remainBrushCountContent = this.querySelector('.js-remain-brush-count');
    this.remainCanisterCountContent = this.querySelector('.js-remain-canister-count');
    const addedItemFlavors = this.getFlavors(); 
    const addedItemBrushes = this.getBrushes(); 
    const addedItemCanisters = this.getCanisters(); 
    let selectedTotalFlavorsCount = 0;
    let selectedTotalBrushesCount = 0;
    let selectedTotalCanisterCount = 0;
    const plusFlavorButtons = this.querySelectorAll('.bab-block-flavor-cell button[name="plus"]');
    const plusBrushButtons = this.querySelectorAll('.bab-block-brush-color-cell button[name="plus"]');
    const plusCanisterButtons = this.querySelectorAll('.bab-block-canister-color-cell button[name="plus"]');

    addedItemFlavors.forEach((addedItemFlavor) => {
        selectedTotalFlavorsCount = selectedTotalFlavorsCount + parseInt(addedItemFlavor.count);
    });
    addedItemBrushes.forEach((addedItemBrush) => {
        selectedTotalBrushesCount = selectedTotalBrushesCount + parseInt(addedItemBrush.count);
    });
    addedItemCanisters.forEach((addedItemCanister) => {
        selectedTotalCanisterCount = selectedTotalCanisterCount + parseInt(addedItemCanister.count);
    });

    if(((parseInt(selectedPerson) * 4) - selectedTotalFlavorsCount) > 0){
        plusFlavorButtons.forEach((plusFlavorButton) => {
            plusFlavorButton.classList.remove('disabled');
        })
    }else{
        plusFlavorButtons.forEach((plusFlavorButton) => {
            plusFlavorButton.classList.add('disabled');
        })
    }
    this.remainCountContent.innerText = `${(parseInt(selectedPerson) * 4) - selectedTotalFlavorsCount}`;

    if(((parseInt(selectedPerson) * 2) - selectedTotalBrushesCount) > 0){
        plusBrushButtons.forEach((plusBrushButton) => {
            plusBrushButton.classList.remove('disabled');
        })
    }else{
        plusBrushButtons.forEach((plusBrushButton) => {
            plusBrushButton.classList.add('disabled');
        })
    }
    this.remainBrushCountContent.innerText = `${(parseInt(selectedPerson) * 2) - selectedTotalBrushesCount}`;

    if((parseInt(selectedPerson) - selectedTotalCanisterCount) > 0){
        plusCanisterButtons.forEach((plusCanisterButton) => {
            plusCanisterButton.classList.remove('disabled');
        })
    }else{
        plusCanisterButtons.forEach((plusCanisterButton) => {
            plusCanisterButton.classList.add('disabled');
        })
    }
    this.remainCanisterCountContent.innerText = `${parseInt(selectedPerson) - selectedTotalCanisterCount}`;

    this.totalItemCounts.forEach((totalItemCount) => {
        totalItemCount.innerText = `${parseInt(selectedPerson) * 4}`;
    })
  }

  getFlavors() {
    this.flavorsList = this.querySelectorAll('.bab-block-flavor-cell');
    this.flavor = [];

    this.flavorsList.forEach((flavorCell) => {
        const title = flavorCell.querySelector('.bab-block-flavor-cell-title').innerText;
        const variantid = flavorCell.getAttribute('data-variantid');
        const productid = flavorCell.getAttribute('data-productid');
        const subscriptionid = flavorCell.getAttribute('data-subscription');
        const count = flavorCell.querySelector('input').value;
        const flavorCellValue = {'title': title,'productid': productid, 'count': count, 'variantid': variantid, 'subscriptionid': subscriptionid };

        this.flavor.push(flavorCellValue);
    });

    return this.flavor;
  }

  getBrushes() {
    this.brushesList = this.querySelectorAll('.bab-block-brush-color-cell');
    this.brush = [];

    this.brushesList.forEach((brushcell) => {
        const title = brushcell.querySelector('.bab-block-brush-color-cell-title').innerText;
        const count = brushcell.querySelector('input').value;
        const variantid = brushcell.querySelector('.bab-block-brush-color-cell-label').getAttribute('data-variantid');
        const productid = brushcell.querySelector('.bab-block-brush-color-cell-label').getAttribute('data-productid');
        const subscriptionid = brushcell.querySelector('.bab-block-brush-color-cell-label').getAttribute('data-subscription');
        const brushCellValue = {'title': title,'productid': productid, 'count': count, 'variantid': variantid, 'subscriptionid': subscriptionid};

        this.brush.push(brushCellValue);
    });

    return this.brush;
  }

  getCanisters(){
    this.canisterList = this.querySelectorAll('.bab-block-canister-color-cell');
    this.canister = [];

    this.canisterList.forEach((canstercell) => {
        const title = canstercell.querySelector('.bab-block-canister-color-cell-title').innerText;
        const count = canstercell.querySelector('input').value;
        const canstercellValue = {'title': title, 'count': parseInt(count)};

        this.canister.push(canstercellValue);
    });

    return this.canister;
  }

  updatePersonPrice(brushOption){
    const personSubBlocks = this.querySelectorAll('.bab-sub-count-block');

    personSubBlocks.forEach((personSubBlock) => {
        const personInput = personSubBlock.querySelector('input');
        const personPrice = personInput.getAttribute('data-price');
        const personBrushPrice = personInput.getAttribute('data-brush-price');
        const personCrossPrice = personInput.getAttribute('data-cross-price');
        const personOriginalPrice = personInput.getAttribute('data-original-price');
        const personPerPrice = personInput.getAttribute('data-person-price');
        const personPerBrushPrice = personInput.getAttribute('data-person-brush-price');
        const priceWrap = personSubBlock.querySelector('.m-price');
        const priceDWrap = personSubBlock.querySelector('.d-price');
        const pricePWrap = personSubBlock.querySelector('.p-price');
        if(brushOption == 'bam'){
            priceWrap.innerText = personBrushPrice;
            priceDWrap.innerText = personOriginalPrice;
            pricePWrap.innerText = personPerBrushPrice;
        }else{
            priceWrap.innerText = personPrice;
            priceDWrap.innerText = personCrossPrice;
            pricePWrap.innerText = personPerPrice;
        }
    })
  }

  atcUpdates(){
    const addedItemFlavors = this.getFlavors(); 
    const addedItemBrushes = this.getBrushes();
    const addedItemCanisters = this.getCanisters();
    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked').value;
    let selectedTotalFlavorsCount = 0;
    let selectedTotalBrushesCount = 0;
    let selectedTotalCanistersCount = 0;
    let actAvailable = false;

    addedItemFlavors.forEach((addedItemFlavor) => {
        selectedTotalFlavorsCount = selectedTotalFlavorsCount + parseInt(addedItemFlavor.count);
    });
    addedItemBrushes.forEach((addedItemBrush) => { 
        selectedTotalBrushesCount = selectedTotalBrushesCount + parseInt(addedItemBrush.count);
    });
    addedItemCanisters.forEach((addedItemCanister) => { 
        selectedTotalCanistersCount = selectedTotalCanistersCount + parseInt(addedItemCanister.count);
    });

    if(this.querySelector('input[name="bab-block-brush-input"]:checked').value == 'bam'){
      if(((parseInt(selectedPerson) * 2) == selectedTotalBrushesCount) && ((parseInt(selectedPerson) * 4) == selectedTotalFlavorsCount) && (parseInt(selectedPerson) == selectedTotalCanistersCount)){
        actAvailable = true;
      }
    }else{
      if(((parseInt(selectedPerson) * 4) == selectedTotalFlavorsCount) && (parseInt(selectedPerson) == selectedTotalCanistersCount)){
        actAvailable = true;
      }
    }

    if(actAvailable){
        this.atcButton.disabled = false;
    }else{
        this.atcButton.disabled = true;
    }
  }

  onButtonClick = async (event) => {
    event.preventDefault();
    this.atcButton.disabled = true;

    let items = [];
    const selectedCanisterInput = this.querySelector('input[name="bab-block-canister-color-input"]:checked');
    const addedItemFlavors = this.getFlavors();
    const addedItemBrushes = this.getBrushes();
    const addedItemCanisters = this.getCanisters();
    const selectedVariant = this.getVariant();
    const bundleProductData = {
      productId: bundle_product.id,
      variantId: selectedVariant.variant_id,
      sellingPlan: 6942687462,
      handle: 'toothpaste-subscription-fixed',
      collectionId: 484854137062
    };

    let selections = [];
    let properties = {};
    let attributes = {};

    addedItemFlavors.forEach(item => {
        if(parseInt(item.count) > 0){
          selections.push({'collectionId': bundleProductData.collectionId,'externalProductId': parseInt(item.productid), 'externalVariantId': parseInt(item.variantid), 'quantity': parseInt(item.count)});
          properties[item.title] = item.count;
        }
    });

    if(this.querySelector('input[name="bab-block-brush-input"]:checked').value == 'bam'){
        addedItemBrushes.forEach(item => {
            if(parseInt(item.count) > 0){
              selections.push({'collectionId': bundleProductData.collectionId,'externalProductId': parseInt(item.productid), 'externalVariantId': parseInt(item.variantid), 'quantity': parseInt(item.count)});
              properties[item.title] = item.count;
            }
        });
    }

    const selection = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: selections,
    };

    const _rb_id = await recharge.bundle.getBundleId(selection, {});

    properties = {_rb_id,};

    addedItemFlavors.forEach(item => {
      properties[item.title] = item.count;
    });

    if(this.querySelector('input[name="bab-block-brush-input"]:checked').value == 'bam'){
      addedItemBrushes.forEach(item => {
          properties[item.title] = item.count;
      });
    }

    addedItemCanisters.forEach(item => {
      if(item.count > 0){
        attributes[item.title] = item.count;
        properties[item.title + ' Canister'] = item.count;
      }
    });

    items = [
        {
          id: bundleProductData.variantId,
          quantity: 1,
          selling_plan: bundleProductData.sellingPlan,
          properties: properties,
        },
      ];

    const cartData = {
      items: items,
    };

    console.log({ bundleConfiguration: await recharge.cdn.getCDNBundleSettings(bundleProductData.productId) });
    console.log('items', selection, cartData, attributes);
    //return false;

    await fetch(`${window.Shopify.routes.root}` + 'cart/clear.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    }).then(response => {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartData)
        })
        .then(response => {
            return response.json();
        })
        .then(response => {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: attributes
              })
            }).then(response => {
                window.location.href = '/checkout';
              });
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
  }

  getVariant(){
    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked').value;
    const availableVariants = bundle_p_variants.filter(bundle_p_variant => bundle_p_variant.person_count == selectedPerson);
    const selectedBrush = this.querySelector('input[name="bab-block-brush-input"]:checked').value;
    let selectedVariant = availableVariants[0];

    if(selectedBrush == 'bam'){
        return availableVariants.find(availableVariant => availableVariant.variant.option2 == "Include Toothbrushes");
    }else{
        return availableVariants.find(availableVariant => availableVariant.variant.option2 == "Exclude Toothbrushes");
    }
  }
}

customElements.define('build-a-bundle', BuildaBundle);

class BabQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('bab-quantity-input', BabQuantityInput);